import { FunctionComponent, useEffect, useLayoutEffect, useState } from "react";
import StarIcon from "@mui/icons-material/Star"; // Import a star icon from MUI
import "./InstructionPractice.scss";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../Redux/Store/Hooks";
import {
  clearListExamID,
  listExamID,
} from "../../Redux/Slices/Exam/ListExamIDSlice";
import { addStudentExam } from "../../Redux/Slices/StudentExam/AddStudentExamSlice";
import { decode } from "../../Utils/encodeDecode";
import { ILoginResponse } from "../Login/ILogin";
import {
  clearlistStudentExam,
  listStudentExam,
} from "../../Redux/Slices/StudentExam/ListStudentExamSlice";
import {
  AppBar,
  Button,
  CircularProgress,
  CssBaseline,
  SvgIcon,
  Toolbar,
} from "@mui/material";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import ReportGmailerrorredIcon from "@mui/icons-material/ReportGmailerrorred";
import { clearlistInstructionPracticeExamID, listInstructionPracticeExamID } from "../../Redux/Slices/PracticeExam/ListinstructionPracticeExamIDSlice";
import {
  clearListPracticeExamID,
  listPracticeExamID,
} from "../../Redux/Slices/PracticeExam/ListPracticeExamIDSlice";
import { ReactComponent as Logo } from "../../Assets/Images/loginlogo.svg";
import { listStudentExamPractice } from "../../Redux/Slices/StudentExamPractice/ListStudentExamPracticeSlice";
import {
  clearEditStudentExamPracticeResponse,
  EditStudentExamPractice,
} from "../../Redux/Slices/StudentExamPractice/EditStudentExamPracticeSlice";
import InfoIcon from "@mui/icons-material/Info";
import AppBarnav from "../../Components/AppBar/AppBar";
import {
  Box,
  Card,
  CardContent,
  Grid,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import TaskAltIcon from "@mui/icons-material/TaskAlt";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";

interface InstructionPracticeProps { }

const InstructionPractice: FunctionComponent<InstructionPracticeProps> = () => {
  // Create an array of instruction objects
  const navigate = useNavigate();
  const { state: exam_id } = useLocation();
  const dispatch = useAppDispatch();

  console.log("exam_idWW", exam_id)

  const { data: listInstructionPracticeExamSlice, isLoading: instructionsLoading } = useAppSelector(
    (state) => state.ListInstructionPracticeExamSlice
  ) as { data?: any; isLoading: boolean };
  const ListInstructionPracticeExamSlices: any =
    listInstructionPracticeExamSlice?.data;

  const ListInstructionPractice =
    ListInstructionPracticeExamSlices?.test_instructions;

  const { data: listexamlist, isLoading: listexamlistLoading } = useAppSelector(
    (state) => state.ListPracticeExamIDSlice
  );

  const [details, setDetails] = useState<ILoginResponse>({});

  const { data: listStudentExamSlice } = useAppSelector(
    (state) => state.ListStudentExamPracticeSlice
  );
  const ListStudentExam: any = listStudentExamSlice?.data;
  const { data: EditStudentPractice } = useAppSelector(
    (state) => state.EditStudentExamPracticeSlice
  );

  useLayoutEffect(() => {
    const timeoutId = setTimeout(() => {
      dispatch(listStudentExamPractice());
    }, 1500); // 5000 milliseconds = 5 seconds
    return () => clearTimeout(timeoutId);
  }, []);

  useLayoutEffect(() => {
    dispatch(clearlistInstructionPracticeExamID());
    dispatch(listInstructionPracticeExamID({ test_id: exam_id.id }));
  }, [exam_id]);

  useLayoutEffect(() => {
    if (ListStudentExam) {
      const timeout = setTimeout(() => {
        dispatch(
          listPracticeExamID({
            student_test_id: ListStudentExam?.id
            // created_on: timestamp,
            // updated_on: timestamp,
          })
        );
      }, 2000);
      return () => clearTimeout(timeout);
    }
  }, [ListStudentExam]);

  useEffect(() => {
    // Check if "details" exists in sessionStorage before decoding
    const storedDetails = sessionStorage.getItem("details");
    if (storedDetails) {
      const userDetails = decode(storedDetails);
      setDetails(userDetails);
    }
    dispatch(clearListPracticeExamID());

    // Only re-run if `ListInstructionPracticeExamSlices` is relevant
  }, [ListInstructionPracticeExamSlices]);

  const [showLoading, setShowLoading] = useState(true);

  // Set the initial "Loading questions" display
  useEffect(() => {
    const initialTimeout = setTimeout(() => {
      setShowLoading(false); // Allow normal loading state to take over
    }, 20); // 5 seconds
    return () => clearTimeout(initialTimeout);
  }, []);
  const [isNavigating, setIsNavigating] = useState(false);

  const handleButtonClick = () => {
    setIsNavigating(true);
    navigate("/practiceexam", { state: { examID: exam_id.id, Practice: "test" } });
    sessionStorage.setItem(
      "timestorage",
      ListInstructionPracticeExamSlices?.total_timing
    );
  };
  // const PendingTime = sessionStorage.getItem("pending_time");
  // const Response = sessionStorage.getItem("response");
  // const question_id = Number(sessionStorage.getItem("question_id"));
  // const Question_Type = Number(sessionStorage.getItem("question_type"));
  // const StudentExamId = Number(sessionStorage.getItem("student_exam_id"));
  // // useEffect(() => {
  // //   dispatch(
  // //     EditStudentExamPractice({
  // //       pending_time: PendingTime,
  // //       student_test_id: StudentExamId,
  // //       question_type_id: Question_Type,
  // //       question_id: question_id,
  // //       response: Response,
  // //     })
  // //   );
  // // }, [dispatch]);

  // useEffect(() => {
  //   if (EditStudentPractice?.status === true) {
  //     navigate("/instructionpendingpractice", {
  //       state: StudentExamId,
  //     });
  //     sessionStorage.removeItem("pending_time");
  //     sessionStorage.removeItem("response");
  //     sessionStorage.removeItem("question_id");
  //     sessionStorage.removeItem("question_type");
  //   }
  // }, [EditStudentPractice]);

  useEffect(() => {
    return () => {
      dispatch(clearEditStudentExamPracticeResponse());
    };
  }, []);

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <>
      <Box sx={{ display: "flex", height: "1px" }}>
        <CssBaseline />
        <AppBar
          position="fixed"
          sx={{
            zIndex: (theme) => theme.zIndex.drawer + 1,
            backgroundColor: "#FFFFFF",
            display: "flex",
            boxShadow: "0px 4px 40px 0px #0000000D",
          }}
        >
          <Toolbar
            sx={{
              minHeight: "0px",
              display: "flex",
              justifyContent: "space-between",
              paddingLeft: "0px",
              paddingRight: "0px",
              margin: "0% 8%",
              height: "50px",
            }}
          >
            <Typography variant="h6" noWrap component="div">
              <SvgIcon
                sx={{
                  width: "123px",
                  height: "50px",
                  marginTop: "10px",
                  cursor: "pointer",
                }}
                color="primary"
                component={Logo}
                inheritViewBox
              />
            </Typography>
            <div style={{ display: "flex", gap: "20px", alignItems: "center" }}>
              <div
                style={{
                  display: "flex",
                  color: "#009dff",
                  fontSize: "16px",
                  alignItems: "center",
                  cursor: "pointer",
                }}
                onClick={() => {
                  navigate("/practicetest"); // Replace with your target route
                }}
              >
                <ArrowBackIosIcon sx={{ color: "#009dff" }} />
                <div style={{ color: "#009dff", fontSize: "15px" }}>
                  {" "}
                  Back To Practice Test
                </div>
              </div>
            </div>
          </Toolbar>
        </AppBar>

        <Box
          component="main"
          sx={{ flexGrow: 1, height: "100vh", width: "100%" }}
        >
          <Outlet />
          {(isNavigating) && (
            <Box
              sx={{
                position: "fixed",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                backgroundColor: "rgba(255, 255, 255, 0.5)",
                zIndex: 9999,
              }}
            >
              <CircularProgress />
            </Box>
          )}
        </Box>
      </Box>
      <Box
        sx={{
          marginTop: "50px",
          backgroundColor: "#f5f9ff",
          minHeight: "100vh",
          py: 5,
          px: 2,
          display: "flex",
          justifyContent: "center",
          alignItems: "flex-start",
        }}
      >
        {instructionsLoading || !ListInstructionPractice ? (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "50vh",
              width: "100%",
            }}
          >
            <CircularProgress />
          </Box>
        ) : (
          <Grid container spacing={4} justifyContent="center" maxWidth="lg">
            <Grid item xs={12}>
              <Typography
                variant="h3"
                fontWeight="bold"
                textAlign="center"
                color="#1e3a8a"
              >
                {ListInstructionPracticeExamSlices?.test_name}
              </Typography>
              <Typography
                variant="body1"
                textAlign="center"
                maxWidth="700px"
                mx="auto"
                fontSize="19px"
                mt={1}
                color="#4b5563"
              >
                {ListInstructionPracticeExamSlices?.test_description}
              </Typography>
            </Grid>

            {/* Instructions Card */}
            <Grid item xs={12} md={6}>
              <Card
                sx={{
                  p: 2,
                  borderRadius: "12px",
                  boxShadow: "0px 37px 37px rgba(0, 157, 255, 0.1)",
                }}
              >
                <CardContent>
                  <Typography
                    variant="h6"
                    fontWeight="bold"
                    gutterBottom
                    sx={{
                      color: "#111827",
                      fontSize: "1.7rem",
                      marginBottom: "15px",
                    }}
                  >
                    Please Read Instructions Carefully
                  </Typography>

                  <Box mb={2}>
                    {ListInstructionPractice?.map((item: any, index: any) => (
                      <Typography variant="body1" key={index} gutterBottom>
                        {/* <div key={index} className="instructionitem"> */}

                        <div
                          style={{
                            fontSize: "18px",
                            marginBottom: "20px",
                            display: "flex",
                            alignItems: "center",
                            gap: "10px",
                          }}
                        >
                          <span
                            style={{
                              height: "20px",
                              // width: "20px",
                              backgroundColor: "#009dff",
                              color: "#374151",
                              borderRadius: "50%",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              padding: "9px",
                              // marginRight: "8px",
                            }}
                          >
                            <span
                              style={{
                                height: "4px",
                                width: "4px",
                                backgroundColor: "#ffffff",
                                borderRadius: "50%",
                                display: "inline-block",
                              }}
                            />
                          </span>

                          {item?.instruction}
                        </div>
                      </Typography>
                    ))}
                  </Box>

                  {listexamlist?.data ? (
                    <Box
                      display="flex"
                      gap={2}
                      flexDirection={isMobile ? "column" : "row"}
                    >
                      <Button
                        variant="contained"
                        color="primary"
                        fullWidth
                        sx={{
                          textTransform: "capitalize",
                          fontSize: "17px",
                          color: "white",
                          "&:hover": {
                            backgroundColor: "#009dff",
                          },
                        }}
                        onClick={handleButtonClick}
                      >
                        Start Test
                      </Button>
                      <Button
                        variant="outlined"
                        color="primary"
                        fullWidth
                        sx={{
                          textTransform: "capitalize",
                          fontSize: "17px",
                          backgroundColor: "white",
                          color: "#009dff",
                          borderColor: "#009dff",
                          "&:hover": {
                            borderColor: "#009dff",

                            backgroundColor: "white",
                            color: "#009dff",
                          },
                        }}
                        onClick={() => {
                          navigate("/dashboard"); // Replace with your target route
                        }}
                      >
                        Back To Practice Tests
                      </Button>
                    </Box>
                  ) : (
                    <>
                      <Button
                        variant="contained"
                        color="primary"
                        fullWidth
                        disabled={true}
                        onClick={handleButtonClick}
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          textTransform: "capitalize",
                          fontSize: "17px",
                          color: "white",

                          "&:hover": {
                            backgroundColor: "#009dff",
                            color: "white",
                          },
                        }}
                      >
                        <div>Loading questions</div>
                        <div>
                          <CircularProgress
                            size={20}
                            sx={{
                              color: "white",
                              marginLeft: "10px",
                            }}
                          />
                        </div>
                      </Button>
                      <div className="vaidationforwriting">
                        <InfoIcon />
                        <div>
                          Please wait while the questions are being prepared. The
                          test will begin shortly{" "}
                        </div>
                      </div>
                    </>
                  )}
                </CardContent>
              </Card>
            </Grid>

            {/* Test Includes Card */}
            <Grid item xs={12} md={3}>
              <Card
                sx={{
                  // p: 2,
                  borderRadius: "12px",
                  backgroundColor: "#f5faff",
                  boxShadow: "0px 37px 37px rgba(0, 157, 255, 0.1)",
                  border: "1px solid #e0f0ff",
                }}
              >
                <CardContent>
                  <Typography
                    variant="h6"
                    fontWeight="bold"
                    gutterBottom
                    sx={{ color: "#111827", fontSize: "1.7rem" }}
                  >
                    Test Includes
                  </Typography>

                  <Box
                    sx={{
                      p: 2,
                      borderRadius: "10px",
                      backgroundColor: "white",
                      mb: 2,
                      border: "1px solid #dceeff",
                    }}
                  >
                    <Typography sx={{ fontWeight: "bold", fontSize: "1.3rem" }}>
                      {ListInstructionPracticeExamSlices?.question_type_name}
                    </Typography>

                    <Typography
                      variant="body2"
                      sx={{
                        mt: 1,
                        display: "flex",
                        justifyContent: "space-between",
                        fontSize: "1.3rem",
                        alignItems: "center",
                      }}
                    >
                      <span style={{ color: "#4B5563", fontSize: "1.3rem" }}>
                        Question type:
                      </span>{" "}
                      <div style={{ fontWeight: 500, color: "black" }}>
                        {ListInstructionPracticeExamSlices?.question_type_name ===
                          "Writing"
                          ? "Essay"
                          : "MCQ"}
                      </div>
                    </Typography>
                    {ListInstructionPracticeExamSlices?.question_type_name ===
                      "Writing" && (
                        <Typography
                          variant="body2"
                          sx={{
                            mt: 1,
                            display: "flex",
                            justifyContent: "space-between",
                            fontSize: "1.3rem",
                            alignItems: "center",
                          }}
                        >
                          <span style={{ color: "#4B5563", fontSize: "1.3rem" }}>
                            Prompt:
                          </span>{" "}
                          <div style={{ fontWeight: 500, color: "black" }}>
                            {ListInstructionPracticeExamSlices?.question_count ??
                              "-"}
                          </div>
                        </Typography>
                      )}

                    <Typography
                      variant="body2"
                      sx={{
                        mt: 1,
                        display: "flex",
                        justifyContent: "space-between",
                        fontSize: "1.3rem",
                        alignItems: "center",
                      }}
                    >
                      <span style={{ color: "#4B5563", fontSize: "1.3rem" }}>
                        {ListInstructionPracticeExamSlices?.question_type_name ===
                          "Writing"
                          ? "Word count:"
                          : "Question count:"}
                      </span>{" "}
                      <div style={{ fontWeight: 500, color: "black" }}>
                        {ListInstructionPracticeExamSlices?.question_type_name ===
                          "Writing"
                          ? "300-400"
                          : ListInstructionPracticeExamSlices?.question_count ??
                          "-"}
                      </div>
                    </Typography>

                    <Typography
                      variant="body2"
                      sx={{
                        mt: 1,
                        display: "flex",
                        justifyContent: "space-between",
                        fontSize: "1.3rem",
                        alignItems: "center",
                      }}
                    >
                      <span style={{ color: "#4B5563", fontSize: "1.3rem" }}>
                        Duration:
                      </span>
                      <div style={{ fontWeight: 500, color: "black" }}>
                        {ListInstructionPracticeExamSlices?.total_timing ?? "-"}{" "}
                      </div>
                    </Typography>
                  </Box>

                  <Box
                    sx={{
                      borderTop: "1px solid #e0e0e0",
                      pt: 2,
                      display: "flex",
                      justifyContent: "space-around",
                      flexWrap: "wrap",
                    }}
                  >
                    <Box display="flex" alignItems="center" gap={1} mb={1}>
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                        }}
                      >
                        <div>
                          {" "}
                          <AccessTimeIcon
                            sx={{ color: "#009DFF", fontSize: "3rem" }}
                          />
                        </div>
                        <Typography
                          variant="caption"
                          sx={{ color: "#666", fontSize: "1rem" }}
                        >
                          DURATION
                        </Typography>
                        <Typography
                          fontWeight="bold"
                          variant="body2"
                          sx={{ fontSize: "1.2rem" }}
                        >
                          {(
                            ListInstructionPracticeExamSlices?.total_timing || "-"
                          ).replace(/\s*minutes\s*,?/, " min")}
                        </Typography>
                      </Box>
                    </Box>

                    <Box display="flex" alignItems="center" gap={1} mb={1}>
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                        }}
                      >
                        <div>
                          <TaskAltIcon
                            sx={{ color: "#009DFF", fontSize: "3rem" }}
                          />
                        </div>
                        <Typography
                          variant="caption"
                          sx={{ color: "#666", fontSize: "1rem" }}
                        >
                          {ListInstructionPracticeExamSlices?.question_type_name ===
                            "Writing"
                            ? "WORDS"
                            : "QUESTIONS"}
                        </Typography>
                        <Typography
                          fontWeight="bold"
                          variant="body2"
                          sx={{ fontSize: "1.2rem" }}
                        >
                          {ListInstructionPracticeExamSlices?.question_type_name ===
                            "Writing"
                            ? "300-400"
                            : ListInstructionPracticeExamSlices?.question_count ??
                            "-"}
                        </Typography>
                      </Box>
                    </Box>
                  </Box>
                </CardContent>
              </Card>
            </Grid>
          </Grid>
        )}
      </Box>
    </>
  );
};

export default InstructionPractice;
